import React, { useState, useEffect, useMemo } from 'react';
import {
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  CustomInput,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IAuthReduxProps, IDesistementClientTable, ITarget } from '../../types/interfaces';
import ClientScanModal from '../client/ClientScanModal';

import { getFtpScan } from '../../flux/actions/clientActions';
import TableContainer from "../tables_manager/TableContainer"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faInfoCircle, faExternalLinkAlt, faPrint, faPhone, faClipboard, faCheckCircle, faIdCard } from '@fortawesome/free-solid-svg-icons'
import moment from "moment";
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import Loading from '../Loading';
import ReactTooltip from 'react-tooltip';
import PDFLink from '../pdf/PDFLink';
import CDTSwitchCell from '../tables_manager/CDTSwitchCell';
import { PRIVILEGE } from '../../types/privileges';

const DesistementClientTable = ({ 
  setTableData,
  linesData,
  panelNumber,
  duplicateClient,
  setDuplicateClient,
  enableDesistement,
  enableTransfert,
  auth
 }: IDesistementClientTable) => {
  const alert = useAlert();
  const skipResetRef = React.useRef(false);
  
  const [copiedFlag, setCopiedFlag] = useState(false);
  const [copiedFlag2, setCopiedFlag2] = useState(false);
  const [modalScan, setModalScan] = useState(false);
  const [modalScanClient, setModalScanClient] = useState('');

  const handleCopy = (e, id = 1) => {
    let phone = (e || "").toString().replace(/ /g,'');
    if(phone.length >= 4 && phone[0] !== "0")
      phone = "+" + phone
    alert.info(`Le numéro de téléphone "${phone}" a été copié.`);
    window.navigator.clipboard.writeText(phone);
    if(id == 1){
      setCopiedFlag(true);
      setTimeout(() => setCopiedFlag(false), 2000);
    }
    else if(id == 2){
      setCopiedFlag2(true);
      setTimeout(() => setCopiedFlag2(false), 2000);
    }
  };

  const columns = [
    ...(!!(/*auth?.user?.privileges?.includes(PRIVILEGE.TRANSFERT) && */!!enableTransfert) ? [{
      Header: "Transférer",
      accessor: "transfere",
      Cell: CDTSwitchCell,
      className: "text-center",
      disableFilters: true,
    }] : []),
    ...(!!(/*auth?.user?.privileges?.includes(PRIVILEGE.DESISTEMENT) && */!!enableDesistement) ? [{
      Header: "Désister",
      accessor: "desiste",
      Cell: CDTSwitchCell,
      className: "text-center",
      disableFilters: true,
    }] : []),
    ...(!!(/*auth?.user?.privileges?.includes(PRIVILEGE.DESISTEMENT) && */!!enableDesistement) ? [{
      Header: "Désister partiellement",
      accessor: "desiste_p",
      Cell: CDTSwitchCell,
      // Cell: CPDTSwitchCell,
      className: "text-center",
      disableFilters: true,
    }] : []),
    {
      Header: "ID Client",
      accessor: (row, index) => row.client?.id || "",
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Nom complet",
      accessor: "nom_complet",
      filter: (rows, id, e) => rows.filter(t => t.original.client?.NOM?.toString().toLowerCase().includes((e || "").toLowerCase()) || t.original.client?.PRENOM?.toString().toLowerCase().includes((e || "").toLowerCase())),
      Cell: ({ row: {original} }) => `${original.client?.NOM || "-"} ${original.client?.PRENOM || ""}`
    },
    {
      Header: "CIN/Passeport",
      accessor: "cin_passport",
      filter: (rows, id, e) => rows.filter(t => t.original.client?.CIN?.toString().toLowerCase().includes((e || "").toLowerCase()) || t.original.client?.PASSPORT?.toString().toLowerCase().includes((e || "").toLowerCase())),
      Cell: ({ row: {original} }) => original.client?.PASSPORT || original.client?.CIN || "-"
    },
    {
      Header: "Numéro(s) de Téléphone",
      accessor: "TEL",
      disableSortBy: true,
      Cell: ({ row }) => row.original.client && (row.original.client.TEL || row.original.client.TEL2) ? <div>
        {row.original.client.TEL ? <div style={{whiteSpace: "nowrap"}}>
          {row.original.client.TEL.length >= 4 && row.original.client.TEL[0] !== "0" ? ("+" + row.original.client.TEL) : row.original.client.TEL}
          <a data-tip data-for="telI" href={`tel:${(row.original.client.TEL.length >= 4 && row.original.client.TEL[0] !== "0" ? ("+" + row.original.client.TEL) : row.original.client.TEL).replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
          <ReactTooltip effect="solid" place="bottom" id="telI" type="dark"><b>Appeler</b></ReactTooltip>
          <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel" style={{cursor: "pointer"}} onClick={() => handleCopy(row.original.client.TEL)} />
          <ReactTooltip effect="solid" place="bottom" id="tel" type={copiedFlag ? "success" : "dark"}>
            <FontAwesomeIcon icon={copiedFlag ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag ? "Copié" : "Copier"}
          </ReactTooltip>
        </div> : null}
        {row.original.client.TEL2 ? <div style={{whiteSpace: "nowrap"}}>
          {row.original.client.TEL2.length >= 4 && row.original.client.TEL2[0] !== "0" ? ("+" + row.original.client.TEL2) : row.original.client.TEL2}
          <a data-tip data-for="telI2" href={`tel:${(row.original.client.TEL2.length >= 4 && row.original.client.TEL2[0] !== "0" ? ("+" + row.original.client.TEL2) : row.original.client.TEL2).replace(/ /g,'')}`} style={{marginLeft: "5px", marginRight: "10px"}}><FontAwesomeIcon icon={faPhone} /></a>
          <ReactTooltip effect="solid" place="bottom" id="telI2" type="dark"><b>Appeler</b></ReactTooltip>
          <FontAwesomeIcon icon={faClipboard} data-tip data-for="tel2" style={{cursor: "pointer"}} onClick={() => handleCopy(row.original.client.TEL2, 2)} />
          <ReactTooltip effect="solid" place="bottom" id="tel2" type={copiedFlag2 ? "success" : "dark"}>
            <FontAwesomeIcon icon={copiedFlag2 ? faCheckCircle : faClipboard} />&nbsp;&nbsp;{copiedFlag2 ? "Copié" : "Copier"}
          </ReactTooltip>
        </div> : null}
      </div> : "-"
    },
    {
      Header: "Aperçus",
      className: "text-center",
      Cell: ({ row }) => (
          <Container className="actionsContainer">
              {/* <button className="btn btn-danger btn-rounded btn-sm my-0 waves-effect waves-light"
                onClick={() => deleteTableClientC(row.original.id)}
                title="Supprimer de cette liste">
                <FontAwesomeIcon icon={faTrash} />
              </button> */}
              {/* <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light"
                onClick={() => alert.info("en construction")}
                title="Imprimer la fiche du client">
                <FontAwesomeIcon icon={faPrint} />
              </button> */}
              <PDFLink documentType={"client"}
                data={row.original.client}
                download={false}
                buttonText=""
                iconSize="inherit"
                customClassNames="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light"
                customButtonIcon={faPrint}
                allowPrintPreview={true}
                htmlTitle="Imprimer la fiche du client" />
              {row.original.client && (row.original.client.cin_name || row.original.client.passport_name) ? <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                onClick={() => (setModalScanClient(row.original.client), setModalScan(true))}
                title="Aperçu des Scans">
                <FontAwesomeIcon icon={faIdCard} />
              </button> : null}
          </Container>
      ),
      disableSortBy: true,
    }
  ];

  const updateMyData = (rowIndex, columnId, value) => {
    // setSkipPageReset(true);
    skipResetRef.current = true;
    setTableData(old =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          }
        }
        return row
      })
    )
  }

  React.useEffect(() => {
    // setSkipPageReset(false);
    skipResetRef.current = false;
  }, [linesData])

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={linesData} dataName="clients" enableCheckBox={false} disableFilter={true} hideExport={true} isEditable={true} updateMyData={updateMyData} skipPageReset={skipResetRef.current} />
      </Container>

      <Container className="mt-2">
        <Row className="justify-content-center">
          {!!(enableTransfert && linesData.filter(e => !!e.transfere).length) && <Col xs="12" lg="4" className="fullFlexCenter">
            <CustomInput type="switch" id={`duplicateClient_${panelNumber}`} name={`duplicateClientSwitch_${panelNumber}`} label={`Garder le${linesData.filter(e => !!e.transfere).length === 1 ? "" : "(s)"} client${linesData.filter(e => !!e.transfere).length === 1 ? "" : "(s)"} sélectionné${linesData.filter(e => !!e.transfere).length === 1 ? "" : "(s)"} dans les 2 ventes`} checked={duplicateClient} onChange={e => setDuplicateClient(e.target.checked)} />
          </Col>}
        </Row>
      </Container>

      <ClientScanModal modal={modalScan} setModal={setModalScan} modalClient={modalScanClient} setModalClient={setModalScanClient} />
      {/* <Modal isOpen={modalScan} toggle={handleToggleScan} onOpened={modalOpenedHandleScan} onClosed={modalClosedHandleScan} className="modal-dialog-large">
        <ModalHeader toggle={handleToggleScan}><FontAwesomeIcon icon={faIdCard} />&nbsp;&nbsp;Aperçu des Scans{modalScanClient && (modalScanClient["CIN"] || modalScanClient["PASSPORT"]) ? (" - " + (modalScanClient["CIN"] || modalScanClient["PASSPORT"])) : ""}</ModalHeader>
        <ModalBody>
          <Container className="scanPreviewContainer">
            {CINImg || CINLoading ? <Row>
              <Col xs="12">CIN</Col>
              <Col xs="12">{CINLoading ? <Loading /> : <img className="scanPreview" src={CINImg}/>}</Col>
            </Row> : null}
            {passportImg || passportLoading ? <Row>
              <Col xs="12">Passeport</Col>
              <Col xs="12">{passportLoading ? <Loading /> : <img className="scanPreview" src={passportImg}/>}</Col>
            </Row> : null}
          </Container>
        </ModalBody>
      </Modal> */}
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, {  })(DesistementClientTable);
